const baseTheme = {
  '--theme-primary': '#1f7983',
  '--theme-secondary': 'rgb(247, 180, 98)',
  '--theme-text-base': '',
  '--theme-primary-50': 'rgb(222, 231, 233)',
  '--theme-textSecondary': '#595959',
  '--theme-textPrimary': '#011c1a',
  '--theme-primary-light': 'rgb(37, 143, 155)',
  '--theme-sidebar-bg-from': '#fff',
  '--theme-sidebar-bg-to': '#fff',
  '--theme-sidebar-text': '#595959',
  '--theme-sidebar-select-text': '#248c96',
  '--theme-ring-color': 'rgb(31, 121, 131,0.1)',
  '--theme-sidebar-selected-bg': 'rgba(159, 163, 171,0.1)',
  '--theme-error': '#ff4d4f',
};
export default baseTheme;
